import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { EditResponseData, EditResponseSearchModel } from '../common-class/edit-response-data';
import { ParticipationDataService } from '../_services/participation-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomErrorsHandlerService } from '../_services/custom-errors-handler.service';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';
import { Questions, SelectedOptionList } from '../common-class/questions';
import { Group, GroupPiping, Matrix, MatrixPiping } from '../common-class/pages';
import { ParticipationResponseData, ResponseCommanData } from '../common-class/response-data';
import { CommonLogic } from '../COMMON-LOGIC/common-logic';
import { formatDate } from '@angular/common';



@Component({
  selector: 'app-edit-response',
  templateUrl: './edit-response.component.html',
  styleUrls: ['./edit-response.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class EditResponseComponent implements OnInit {
  editResponseSearchModel: EditResponseSearchModel;
  editResponseData: EditResponseData;
  showLoader:boolean=false;
  questionLength: number = 0;
  responseQuestions: Questions[] = [];
  shallowCopyArray: Questions[] = [];
  commonLogic: CommonLogic;
  participationResponseData: ParticipationResponseData;
  isMandatory: boolean = false;
  isPostPopulate:boolean = false;
  isPostEdit:boolean = false;
  showFooter: boolean = false;
  responseSrNo:number = 0;
  

constructor(
    public service: ParticipationDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,
    private changeDetect: ChangeDetectorRef,
    private renderer: Renderer2,
    private elementref: ElementRef,
  ) {  
        this.commonLogic = new CommonLogic();
   }

  ngOnInit(): void {
    this.showLoader = true;
    this.editResponseSearchModel = new EditResponseSearchModel();
    this.editResponseData = new EditResponseData();
       this.activatedRoute.queryParams.subscribe(async (params) => {
         this.editResponseSearchModel.surveyId= params['surveyId'] == '' || params['surveyId'] == undefined ? '' : params['surveyId'];
         this.editResponseSearchModel.surveyNo= params['surveyNo'] == '' || params['surveyNo'] == undefined ? '' : params['surveyNo'];
         this.editResponseSearchModel.lang=0;
         this.editResponseSearchModel.responseUid= params['responseUid'] == '' || params['responseUid'] == undefined ? '' : params['responseUid'];
         this.editResponseSearchModel.isPostPop= params['isPostPop'] == '' || params['isPostPop'] == undefined ? '' : params['isPostPop']; 
         this.editResponseSearchModel.responseNo = params['ResponseNo'] == '' || params['ResponseNo'] == undefined ? '' : params['ResponseNo'];
          let isPostPop = params['isPostPop'];
          if (isPostPop === '' || isPostPop === undefined) {
          this.isPostEdit = false;
          } else {
          this.isPostEdit = isPostPop === 'true';
}
        });

        let editRespUrl: any;
        editRespUrl = 'GetEdit';
        let url: string;
        this.service
          .EditResp  (
            editRespUrl,
            JSON.stringify(
              EncryptionAndDecryption.EncryptionData(
                '123456$#@$^@1ERF',
                JSON.stringify(this.editResponseSearchModel),
              ),
            ),
          ).subscribe(
            async (result) => {
            let arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await result);
            arrData = JSON.parse(arrData);
            this.editResponseData = await arrData.editResponseData;
            this.responseSrNo = this.editResponseSearchModel.responseNo;
            this.service.setCommonSetting(this.editResponseData.commonSetting)
            this.service.setdropDownCount(this.editResponseData.commonSetting.dropDownCount);
            this.service.setImageFolder(this.editResponseData.commonSetting.ImageFolder);
            this.service.setMDDdropDownCount(this.editResponseData.commonSetting.MDDdropDownCount);
            this.service.setSurveyMessages(this.editResponseData.SurveyMessages);
            this.service.setSureyDetails(
              this.editResponseData.SurveyDetails.surveyKey,
              this.editResponseData.ResponseInfo.ResponseUID,
              '',
              this.editResponseData.SurveyMessages.ReEnterBlankMessage,
              '',
              this.editResponseData.CorpSettings.strProduct,
            );
            if(this.editResponseData.Questions.filter(e=> e.mandatory && e.qtype !='CM').length > 0){
              this.isMandatory = true;
            }
            if(this.isPostEdit && this.editResponseData.Questions.filter(e=> e.population_type == 4 || e.population_type == 5).length > 0){
              this.isPostPopulate = true;
            }
            this.editResponseData.Questions.forEach(e =>{
              if(e.population_type != 4 && e.population_type != 5)
              {
                e.population_type = 1;
              }
              e.pipingQuationTitle = e.qtitle;
            });   
            if(this.editResponseData.Groups != null && this.editResponseData.Groups != undefined)
            {
              this.editResponseData.Groups.forEach(e =>{
                e.pipeTitle=e.gtitle;
                e.PipeGTitle = e.gtitle;
              });
            }
            if (this.editResponseData.Matrix != null && this.editResponseData.Matrix != undefined) {
              this.editResponseData.Matrix.forEach(e => {
                e.PipeMTitle = e.Mtitle;
              });
            } 
            this.service.setisEditPostPop(this.isPostEdit);
            this.service.setisEditResponse(true);

            this.SurveyResponseUpdate();
            if (this.editResponseData.Matrix != null && this.editResponseData.Matrix != undefined) {
              this.MatrixGridQuationHandle();
            }
            this.showFooter = true;
            this.showLoader = false;
            this.changeDetect.detectChanges();
          },
          (error) => {
            this.errorsHandlerService.handleError(error);
          },
        );
  }
 trackByUniqueNumber(index: number, question: Questions): string {
    return question.UniqueNumber.toString();
  }


  isPostEditDisable(index:number):boolean{
    const question = this.editResponseData.Questions[index];
    if(this.isPostEdit
      && (question.group_no == 0 && question.population_type != 4 && question.population_type != 5)){
      return true;
    }
    return false;
  }


   /**
   * this method used for prevent event.
   * @param event
   * @returns
   */
   preventEvent(event) {
    if (
      event.keyCode == 13 &&
      event.target.type != '' &&
      event.target.type != 'submit' &&
      event.target.type != 'button' &&
      event.target.type != 'textarea'
    ) {
      return event.preventDefault();
    }
  }

  /**
     * this method use for single question control handle.
     * @param question
     * @param index
     * @returns
     */
    GetQuestionsString(question: Questions, index: number): string {
      if (question.isAnchorReverse && question.qtype == 'R' && question.qsubtype == 2) {
        question.Answers.sort((n1, n2) => n2.value_id - n1.value_id);
      }
  
      if (question.AnswerText == null && question.mandatory && !question.isHiddenQ) {
        question.isMandatoryInvalid = true;
      } else {
        question.isMandatoryInvalid = false;
      }
  
      if (question.Showcharlimit) {
        question.RemainingChr = this.editResponseData.SurveyMessages.RemainingChr;
      }
  
      if (question.qtype == 'CM' && question.qsubtype == 1 && question.AnswerText == undefined) {
        question.AnswerText = null;
      }
  
      if (question.qtype == 'C' || question.qtype == 'ML') {
        if (
          question.ansConstraint != null &&
          question.ansConstraint != '' &&
          question.ansConstraint != 'NULL'
        ) {
          let ansCons = question.ansConstraint.split(' ');
          if (question.error_msg !== null && typeof question.error_msg === 'string') {
            let errorMsg = question.error_msg.replace('<N>', ansCons[1]);
            question.error_msg = errorMsg;
          }
        }
      }
  
      if (this.editResponseData.SurveyMessages.ReEnterBlankMessage != null) {
        question.ReEnterBlankMessage = this.editResponseData.SurveyMessages.ReEnterBlankMessage;
      }
  
      if (question.qtype == 'RK' && question.error_msg != null) {
        let errorMsg = question.error_msg.replace('<N>', question.rank_limit.toString());
        question.error_msg = errorMsg;
      }
  
      if (
        question.qtype == 'T' &&
        question.AnswerText == null &&
        question.date_default != null &&
        (question.qsubtype == 1 ||
          question.qsubtype == 2 ||
          question.qsubtype == 3 ||
          question.qsubtype == 4)
      ) {
        question.AnswerText = question.date_default;
      }
      question.Answers.forEach((element) => {
        let pattern = new RegExp(/(?:<.+.>)(.*?)(?=<.*\/.+.?>)/g);
        if (element.value_text !== null && typeof element.value_text === 'string') {
          if (!pattern.test(element.value_text)) {
            element.value_text = element.value_text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
        }
      });
  
      this.questionLength = 1;
      return JSON.stringify(question);
    }


  
    /**
     * this method use for multi question control handle
     * @param question
     * @param index
     * @returns
     */
    GetMultiQuestionsString(question: Questions,): string {
      let multiQuestions = this.editResponseData.Questions.filter(
        (e) => e.qno == question.qno && e.group_no == question.group_no,
      );
      if (multiQuestions != null && multiQuestions != undefined) {
        let mandatoryObj = multiQuestions.filter((e) => e.mandatory && !e.isHiddenQ);
        for (let question of mandatoryObj) {
          if (question.AnswerText == null && question.mandatory && !question.isHiddenQ) {
            question.isMandatoryInvalid = true;
          } else {
            question.isMandatoryInvalid = false;
          }
        }
        if (multiQuestions[0].piping) {
          let group = this.GetGroupData(multiQuestions[0].group_no);
  
          if (group != undefined && group != null) {
            let groupPiping: GroupPiping = new GroupPiping();
            groupPiping.group_no = multiQuestions[0].group_no;
            groupPiping.pipeTitle =group.gtitle;
            this.service.setPiping(groupPiping);
          }
        }
  
        for (const multiQuestion of multiQuestions) {
          if (this.editResponseData.SurveyMessages.ReEnterBlankMessage != null) {
            question.ReEnterBlankMessage = this.editResponseData.SurveyMessages.ReEnterBlankMessage;
          }
          
          if (multiQuestion.Showcharlimit) {
            multiQuestion.RemainingChr = this.editResponseData.SurveyMessages.RemainingChr;
          }
          if (multiQuestion.qtype == 'C') {
            if (multiQuestion.ansConstraint != null) {
              let ansCons = multiQuestion.ansConstraint.split(' ');
              let errorMsg = multiQuestion.error_msg.replace('<N>', ansCons[1]);
              multiQuestion.error_msg = errorMsg;
            }
          }
          if (
            multiQuestion.qtype == 'T' &&
            multiQuestion.AnswerText == null &&
            multiQuestion.date_default != null &&
            multiQuestion.date_default != '' &&
            (multiQuestion.qsubtype == 1 ||
              multiQuestion.qsubtype == 2 ||
              multiQuestion.qsubtype == 3 ||
              multiQuestion.qsubtype == 4)
          ) {
            multiQuestion.AnswerText = multiQuestion.date_default;
          }
          if (multiQuestion.qtype == 'RK' && multiQuestion.rank_limit > 0) {
            let errorMsg = multiQuestion.error_msg.replace(
              '<N>',
              multiQuestion.rank_limit.toString(),
            );
            multiQuestion.error_msg = errorMsg;
          }
         
          if (multiQuestion.UniqueNumber != question.UniqueNumber) {
            multiQuestion.isMultiQuestion = true;
          }
          if (this.editResponseData.SurveySettings.isMandatoryUpfront) {
            multiQuestion.isMandatoryStar = true;
          }
          let findQuestion = this.editResponseData.Questions.find(
            (e) => e.UniqueNumber == multiQuestion.UniqueNumber,
          );
          if (findQuestion != null && findQuestion != undefined) {
            let ind = this.editResponseData.Questions.indexOf(findQuestion);
            this.editResponseData.Questions[ind] = multiQuestion;
          }
        }
        this.questionLength = multiQuestions.length;
        return JSON.stringify(multiQuestions);
      }
    }

     /**
       * this method use for group data.
       * @param group_no
       * @returns
       */
      GetGroupData(group_no: number): Group {
        if (this.editResponseData.Groups != null) {
          return this.editResponseData.Groups.find((e) => e.group_no == group_no);
        }
      }

        /**
         * this method use for check multiple question
         * @param group
         * @returns
         */
        GetIsMulti(group: Group): boolean {
          if (this.editResponseData.Matrix != null && group != undefined) {
            return this.editResponseData.Matrix.find((e) => e.matrix_id == group.Matrix_id).isMulti;
          }
        }
  MatrixGridQuationHandle() {
    let matrix = this.editResponseData.Matrix.filter((e) => !e.isMulti && !e.IsSingleGrid);
    if (matrix.length > 0) {
      for (const matrixItem of matrix) {
        let groups = this.editResponseData.Groups.filter((e) => e.Matrix_id == matrixItem.matrix_id);
        let grp_ruleID = 0;
        let grp_isCQ = false;
        let grp_isCQHide = false;
        if (groups.length > 0) {
          for (const groupItem of groups) {
              let questions = this.editResponseData.Questions.filter(
                (e) => e.group_no == groupItem.group_no,
              );
              if (questions != null && questions.length > 0) {
                if (questions[0].answer_style == 2) {
                  questions = CommonLogic.RandomQuestionsAnswerHandling(questions);
                }
                let allGrupRule = questions.filter(
                  (e) => e.Rule_id != 0 && e.Rule_id == questions[0].Rule_id,
                );
                let allDiffGrupRule = questions.filter((e) => e.Rule_id != 0);
                if (allGrupRule.length == questions.length) {
                  for (const questionItem of questions) {
                    questionItem.isGroupRule = true;
                  }
                } else if (allDiffGrupRule.length == questions.length) {
                  for (const questionItem of questions) {
                    questionItem.isNOGroupRule = true;
                  }
                }
                for (const questionItem of questions) {
                  let index = this.editResponseData.Questions.indexOf(questionItem);
                  if (groupItem.isAnchorReverse) {
                      questionItem.Answers.sort((n1, n2) => n2.weight - n1.weight);
                  }
                  if (matrixItem.isBranchEnabled) {
                    let target = matrixItem.TargetGrid.toString().split(',');

                    if (target.indexOf(questionItem.group_no.toString()) >= 0) {
                      this.editResponseData.Questions[index].IsDisabled = true;
                    } else {
                      this.editResponseData.Questions[index].IsDisabled = false;
                    }
                  }
                  this.editResponseData.Questions[index].isMatrixQuestion = true;
                  if (
                    this.editResponseData.Questions[index].qtype == 'GD' ||
                    (this.editResponseData.Questions[index].qtype == 'RW' &&
                      this.editResponseData.Questions[index].qsubtype == 2)
                  ) {
                    this.editResponseData.Questions[index].selectAnsValue = -1;
                  }
                  if (this.editResponseData.Questions[index].Rule_id != 0) {
                    grp_ruleID = this.editResponseData.Questions[index].Rule_id;
                    grp_isCQHide = this.editResponseData.Questions[index].isCQHide;
                    grp_isCQ = this.editResponseData.Questions[index].isCQ;
                  } else if (
                    this.editResponseData.Questions[index].Rule_id == 0 &&
                    grp_ruleID != 0 &&
                    questions[0].isGroupRule
                  ) {
                    this.editResponseData.Questions[index].Rule_id = grp_ruleID;
                    this.editResponseData.Questions[index].isCQHide = grp_isCQHide;
                    this.editResponseData.Questions[index].isCQ = grp_isCQ;
                  }
                }
                break;
              }
          }
        }
      }
    }
  }


          GetMatrixGridQuestionsString(
            question: Questions,
            index: number,
            isValidObj: boolean = false,
          ): string {
            let groupData = this.GetGroupData(question.group_no);
            if (groupData != null && groupData != undefined) {
              let matrixData = this.GetMatrixData(groupData);
              if (matrixData != null && matrixData != undefined) {
                let groupDatas = this.editResponseData.Groups.filter((e) => e.Matrix_id == matrixData.matrix_id);
                if (question.piping) {
                  let matrixPiping: MatrixPiping = new MatrixPiping();
                  matrixPiping.matrix_id = matrixData.matrix_id;
                  matrixPiping.pipeTitle = matrixData.Mtitle;
                  this.service.setMatrixPiping(matrixPiping);
                }
                if (groupDatas != null && groupDatas != undefined) {
                  let matrixQuestions = [];
                  for (const groupDataItem of groupDatas) {
                    let questionDatas = this.editResponseData.Questions.filter(
                      (e) => e.group_no == groupDataItem.group_no,
                    );
                    if (questionDatas.length > 0) {
                      for (const questionDataItem of questionDatas) {
                        if (questionDataItem.UniqueNumber != question.UniqueNumber && !isValidObj) {
                          questionDataItem.isMultiQuestion = true;
                        }
                        if (this.editResponseData.SurveySettings.isMandatoryUpfront && !isValidObj) {
                          questionDataItem.isMandatoryStar = true;
                        }
                      
                        let findQuestion = this.editResponseData.Questions.find(
                          (e) => e.UniqueNumber == questionDataItem.UniqueNumber,
                        );
                        if (findQuestion != null && findQuestion != undefined && !isValidObj) {
                          let ind = this.editResponseData.Questions.indexOf(findQuestion);
                          this.editResponseData.Questions[ind] = questionDataItem;
                        }
                        if (question.qtype == 'RG' && groupDataItem.isAnchorReverse) {
                          
                            questionDataItem.Answers.sort((n1, n2) => n2.weight - n1.weight);
                        } else if (
                          (questionDataItem.qtype == 'GR' || questionDataItem.qtype == 'SR') &&
                          (questionDataItem.qsubtype == 1 ||
                            (questionDataItem.qsubtype == 2 && questionDataItem.qtype == 'GR')) &&
                            groupDataItem.isAnchorReverse
                        ) {
                          questionDataItem.Answers.sort((n1, n2) => n2.value_id - n1.value_id);
                        }
                        if (questionDataItem.Showcharlimit) {
                          questionDataItem.RemainingChr = this.editResponseData.SurveyMessages.RemainingChr;
                        }
                        matrixQuestions.push(questionDataItem);
                      }
                    }
                  }
                  this.questionLength = matrixQuestions.length;
                  return JSON.stringify(matrixQuestions);
                }
              }
            }
          }

     /**
     * this method use for matrix data.
     * @param group
     * @returns
     */
    GetMatrixData(group: Group): Matrix {
      if (this.editResponseData.Matrix != null) {
        return this.editResponseData.Matrix.find((e) => e.matrix_id == group.Matrix_id);
      }
    }
      /**
       * this method use for handle multiple group data.
       * @param matrix
       * @returns
       */
      GetGroupDatas(matrix: Matrix): Group[] {
        if (this.editResponseData.Groups != null) {
          return this.editResponseData.Groups.filter((e) => e.Matrix_id == matrix.matrix_id);
        }
      }

       /**
         * this method use for reopen survey updating responses.
         */
        SurveyResponseUpdate() {
          if (
            this.editResponseData.participationResponseData &&
            this.editResponseData.participationResponseData.ResponseDatas != null
          ) {
           
            for (
              let i = 0;
              i < this.editResponseData.participationResponseData.ResponseDatas.length;
              i++
            ) {
              if (
                this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID == 0 &&
                this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText == null &&
                !this.editResponseData.participationResponseData.ResponseDatas[i].IsOther
              ) {
                continue;
              }

                let question = this.editResponseData.Questions.find(
                  (e) =>
                    e.UniqueNumber ==
                    this.editResponseData.participationResponseData.ResponseDatas[i].QuestionID,
                );
                if (question != null && question != undefined) {
                  let index = this.editResponseData.Questions.indexOf(question);
                  question.AnswerID =
                    this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID;
                  question.AnswerText =
                    this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText;
                  question.selectAnsValue =
                    this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID;
                  if (question.qtype == 'RW' && question.qsubtype == 3) {
                    question.isLoading = true;
                  }
                  if (question.qtype == 'T' && question.isCQHide && question.InlineQDL) {
                    question.isLoading = true;
                  }
                  if (this.editResponseData.participationResponseData.ResponseDatas[i].IsOther) {
                    question.isOtherAnswer =
                      this.editResponseData.participationResponseData.ResponseDatas[i].IsOther;
                    question.otherAnswer = question.AnswerText;
                    question.AnswerText = question.other_text;
                  }
                  if (question.isSoftRequired && !question.isHiddenQ) {
                    question.isSoftRequiredHandle = true;
                  }
                  if (
                    question.Answers != null &&
                    question.Answers != undefined &&
                    question.Answers.length > 0
                  ) {
                    let ans = question.Answers.find(
                      (e) =>
                        e.value_id ==
                        this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID,
                    );
                    if (this.editResponseData.participationResponseData.ResponseDatas[i].IsOther) {
                      ans = question.Answers.find((e) => e.isOther);
                    }
                    if (ans != null && ans != undefined) {
                      if (
                        question.qtype == 'R' ||
                        question.qtype == 'HR' ||
                        question.qtype == 'GR' ||
                        question.qtype == 'RG' ||
                        (question.qtype == 'RW' && question.qsubtype == 0) ||
                        (question.qtype == 'RW' && question.qsubtype == 1) ||
                        (question.qtype == 'RW' && question.qsubtype == 3) ||
                        question.qtype == 'RT' ||
                        question.qtype == 'L' ||
                        question.qtype == 'SR' ||
                        question.qtype == 'GQ'
                      ) {
                        if (!question.isGoBackQuota && !ans.isQuotaDisable) {
                          ans.ControlAns = ans.value_text;
                          question.AnswerID = ans.ms_id;
                          question.selectAnsValue = ans.value_id;
                          question.AnswerText = ans.value_text;
                          ans.selectdId = 1;
                        } else {
                          question.AnswerID = null;
                          question.AnswerText = null;
                          if (question.qtype == 'L') {
                            question.selectAnsValue = -1;
                          }
                        }
                      } else if (question.qtype == 'RS') {
                        if (question.RS_Type == 2 || question.RS_Type == 4 || question.RS_Type == 3 ||(question.RS_Type == 0 && question.RSFormat == 2) ) {
                          ans.ControlAns = ans.value_id.toString();
                        } else {
                          ans.ControlAns = ans.value_id;
                        }
                        question.AnswerID = ans.ms_id;
                        question.selectAnsValue = ans.value_id;
                        question.AnswerText = ans.value_text;
                        ans.selectdId = 1;
                      } else if (
                        question.qtype == 'GD' ||
                        (question.qtype == 'RW' && question.qsubtype == 2)
                      ) {
                        question.AnswerText = ans.value_text;
                      } else if (
                        question.qtype == 'C' ||
                        question.qtype == 'ML' ||
                        question.qtype == 'GC'
                      ) {
                        if (!question.isGoBackQuota && !ans.isQuotaDisable) {
                          ans.ControlAns = true;
                          ans.selectdId = 1;
                          question.AnswerText = 'Selected Answer Option';
                          this.InsertSelectedOptionList(
                            question,
                            this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID,
                            this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText,
                            this.editResponseData.participationResponseData.ResponseDatas[i].IsOther,
                          );
                          if (
                            question.ansConstraint != null &&
                            question.qtype != 'GC' &&
                            question.selectedOptionList.length > 0 &&
                            !ans.IsNoneAbove
                          ) {
                            question = this.AnsConstraintHandling(question);
                          }
                        } else {
                          ans.ControlAns = false;
                          ans.selectdId = 0;
                          question.AnswerID = null;
                          question.AnswerText = null;
                          question.selectAnsValue = -1;
                        }
                      } else if (question.qtype == 'CS' || question.qtype == 'RK') {
                        ans.ControlAns =
                          this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText;
                        question.AnswerText = 'Option Filled';
                        this.InsertSelectedOptionList(
                          question,
                          this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID,
                          this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText,
                          this.editResponseData.participationResponseData.ResponseDatas[i].IsOther,
                        );
                      } else if (question.qtype == 'SC') {
                        ans.ControlAns = ans.value_text;
                        question.AnswerText = 'Option Filled';
                        this.InsertSelectedOptionList(
                          question,
                          this.editResponseData.participationResponseData.ResponseDatas[i].AnswerID,
                          this.editResponseData.participationResponseData.ResponseDatas[i].AnswerText,
                          this.editResponseData.participationResponseData.ResponseDatas[i].IsOther,
                        );
                      } 
                      question.pageto = ans.pageto;
                      let ind = question.Answers.indexOf(ans);
                      if (question.qtype == 'RS'|| (question.qtype=='RG' && question.RSFormat == 2)) {
                        if (ans.isNA) {
                          question.isNA = true;
                        }
                      }
                      question.Answers[ind] = ans;
                    }
                  }
                  if (question.qtype == 'T') {
                    question.pageto = question.Answers[0].pageto;
                    if (question.qsubtype == 21 && question.AllowOnlyInteger) {
                      question.AnswerText = Math.round(parseFloat(question.AnswerText)).toString();
                    }
                  }
                  if (question.qtype == 'CM' && question.qsubtype == 1) {
                    question.AnswerText = null;
                  }
                  this.editResponseData.Questions[index] = question;

                }

            }
          }
        }
        
          /**
           * this method use for handling constraint on control.
           * @param questions
           * @returns
           */
          AnsConstraintHandling(questions: Questions): Questions {
            let ansCons = questions.ansConstraint.split(' ');
            if (ansCons[0] == '=') {
              if (questions.selectedOptionList.length == parseInt(ansCons[1])) {
                questions.isValid = false;
                questions.isAlertDanger = false;
              } else {
                questions.isValid = true;
                questions.isAlertDanger = true;
              }
            } else if (ansCons[0] == '>=') {
              if (questions.selectedOptionList.length >= parseInt(ansCons[1])) {
                questions.isValid = false;
                questions.isAlertDanger = false;
              } else {
                questions.isValid = true;
                questions.isAlertDanger = true;
              }
            } else if (ansCons[0] == '<=') {
              if (questions.selectedOptionList.length <= parseInt(ansCons[1])) {
                questions.isValid = false;
                questions.isAlertDanger = false;
              } else {
                questions.isValid = true;
                questions.isAlertDanger = true;
              }
            }
            return questions;
          }
    /**
       * this method use for multi-value control list insertion
       * @param question
       * @param answerID
       * @param answerText
       * @param isOther
       */
      InsertSelectedOptionList(
        question: Questions,
        answerID: number,
        answerText: string,
        isOther: boolean,
      ) {
        let selectedOptionList: SelectedOptionList[];
        if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
          selectedOptionList = question.selectedOptionList;
        } else {
          selectedOptionList = [];
        }
        let selectedList = selectedOptionList.find((e) => e.value_id == answerID);
        if (selectedOptionList.indexOf(selectedList) < 0) {
          selectedOptionList.push({ value_id: answerID, value_text: answerText, isOther: isOther });
          question.selectedOptionList = selectedOptionList;
        }
      }

       /**
         * this method used for loading time update responses.
         * @param question
         */
        UpdateLoadingQuestionsData(question: Questions) {
          this.UpdateQuestionsData(question, true);
        }


          deepShallowCopyRecursive(obj: any): any {
            if (Array.isArray(obj)) {
              return obj.map(item => this.deepShallowCopyRecursive(item)); 
            }
            if (obj && typeof obj === 'object') {
              const copiedObject: any = { ...obj };
              for (const key in copiedObject) {
                if (copiedObject[key] && typeof copiedObject[key] === 'object') {
                  copiedObject[key] = this.deepShallowCopyRecursive(copiedObject[key]);
                }
              }
              return copiedObject;
            }
            return obj;
          }
      
        /**
         * this method use for collecting child control response data.
         * @param question
         * @param isLoading
         */
        UpdateQuestionsData(question: Questions, isLoading: boolean = false) {

          if (this.isPostEdit && (question.population_type == 4 || question.population_type == 5)) {
            const questionRule = this.editResponseData.questionRules?.find(e => e.ZarcaQId == question.UniqueNumber);

            if (questionRule) {
              if (question.qtype == 'T' && question.AnswerText && questionRule.ResponseDatas[0].AnswerText == '' && questionRule.ConditionValueText == question.AnswerText) {
                alert("You have Rules and Alert pre-defined for this answer option. On submitting this response, an email would be sent based on the criteria mentioned in the Rule.");
              } else {
                
                const responseQuestion = this.shallowCopyArray?.find(e => e.UniqueNumber == question.UniqueNumber);
                const answerOpt = question.Answers.find(e => e.value_id == parseInt(questionRule.ConditionValueID));

                if (answerOpt) {
                  let responseAnswer = null;
                  if (responseQuestion) {
                    responseAnswer = responseQuestion.Answers.find(e => e.value_id == answerOpt.value_id);
                  }
                  if ((responseAnswer && responseAnswer.ControlAns !== answerOpt.ControlAns) || !responseQuestion) {
                    alert("You have Rules and Alert pre-defined for this answer option. On submitting this response, an email would be sent based on the criteria mentioned in the Rule.");
                  }
                }
              }
            }
          }
          if (['T', 'R', 'L', 'HR'].includes(question.qtype) && question.isDirectoryLinkedQ) {
            let linkq = this.editResponseData.directoryLinkedQuestionDetails.linkedQuestions.filter(
              (e) => e.questionID == question.UniqueNumber,
            );
            if (linkq.length > 0) {
              linkq[0].directoryColumnValue = question.AnswerText;
              let lnkind = this.editResponseData.directoryLinkedQuestionDetails.linkedQuestions.indexOf(
                linkq[0],
              );
              this.editResponseData.directoryLinkedQuestionDetails.linkedQuestions[lnkind] = linkq[0];
            }
          }
          if (question.InlineQDL) {
            this.service.SetQDL(question);
          }
          

          if (this.responseQuestions.length > 0 && this.responseQuestions != undefined) {
            let updateItem = this.responseQuestions.find((e) => e.UniqueNumber == question.UniqueNumber);
            if (updateItem != null && updateItem != undefined) {
              let ind = this.responseQuestions.indexOf(updateItem);
              this.responseQuestions[ind] =   question;
            } else {
              this.responseQuestions.push(question);
            }
          } else {
            this.responseQuestions.push(question);
          }
          this.shallowCopyArray.splice(0, this.shallowCopyArray.length);
          this.shallowCopyArray = this.deepShallowCopyRecursive(this.responseQuestions);

        }


        getEditResponseTitle(): string {
          if (this.editResponseData != null && this.editResponseData != undefined) {
          const editRespTitle = this.isPostEdit ? 'Post-Populating Response:' : 'Editing Response:';
          
            if (this.editResponseData.responseSrNo != null && this.editResponseData.responseSrNo != undefined) {
              return editRespTitle + ' ' + this.editResponseData.responseSrNo;
            } else {
              return editRespTitle + ' ';
            }
          } else {
            return  ' ';
          }
        }
        
      
        /**
         * this method remove response from response object
         * @param question
         */
        RemoveUpdateQuestionsData(question: Questions) {
          if (this.responseQuestions.length > 0 && this.responseQuestions != undefined) {
            let updateItem = this.responseQuestions.find((e) => e.UniqueNumber == question.UniqueNumber);
            if (updateItem != null && updateItem != undefined) {
              let ind = this.responseQuestions.indexOf(updateItem);
              this.responseQuestions.splice(ind, 1);
            }
          }
        }
      
        /**
         * this method use for update responses in question data.
         */
        UpdateLocalJson() {
          if (this.responseQuestions.length > 0 && this.editResponseData != null) {
            for (const responseQuestion of this.responseQuestions) {
              let index = this.responseQuestions.indexOf(responseQuestion);
              let updateItem = this.editResponseData.Questions.find(
                (e) => e.UniqueNumber == responseQuestion.UniqueNumber,
              );
              if (updateItem != null && updateItem != undefined) {
                let ind = this.editResponseData.Questions.indexOf(updateItem);
                this.responseQuestions[index].isCQHide = this.editResponseData.Questions[ind].isCQHide;
                if (this.responseQuestions[index].qtype == 'T' && this.responseQuestions[index].InlineQDL) {
                  this.responseQuestions[index].isLoading =
                    this.editResponseData.Questions[ind].isLoading;
                  this.responseQuestions[index].QDLCondStatuses =
                    this.editResponseData.Questions[ind].QDLCondStatuses;
                }
                this.editResponseData.Questions[ind] = this.responseQuestions[index];
              }
            }
            this.responseQuestions = [];
          }
        }

          /**
           * this method use for submit responses.
           * @param isBranchingSubmit
           * @param isAssessmentSubmit
           */
          SubmitData(type:string) {
            this.showLoader = true;
            this.UpdateLocalJson();
            this.participationResponseData = new ParticipationResponseData();
            this.participationResponseData.ResponseDatas = [];
            this.participationResponseData.ResponseCommanData = new ResponseCommanData();


              for (let questionItem of this.editResponseData.Questions) {
                if (
                  questionItem.qtype == 'C' ||
                  questionItem.qtype == 'CS' ||
                  questionItem.qtype == 'RK' ||
                  questionItem.qtype == 'GC' ||
                  questionItem.qtype == 'SC' ||
                  questionItem.qtype == 'ML'
                ) {
                  let answerID = questionItem.selectAnsValue;
                  let answerText = questionItem.AnswerText;
                  let questionType = questionItem.qtype;
                  let questionID = questionItem.UniqueNumber;  
                  let isOther = false;
                  let Qno = questionItem.qno;
                  let page_no = questionItem.page_no;
                  let BranchQID;
                  if (
                    (questionItem.qtype == 'RK' &&
                      (questionItem.selectedOptionList == null ||
                        questionItem.selectedOptionList.length == 0)) ||
                    (questionItem.qtype == 'CS' &&
                      this.commonLogic.isEmptyList(questionItem))
                  ) {
                    answerID = -1;
                  }
                  if (
                    questionItem.selectedOptionList != null &&
                    questionItem.selectedOptionList.length > 0 &&
                    !this.commonLogic.isEmptyList(questionItem)
                  ) {
                    for (
                      const selectedOption of questionItem.selectedOptionList
                    ) {
                      answerID = selectedOption.value_id;
                      answerText = selectedOption.value_text;
                      if (
                        questionItem.qtype == 'C' ||
                        questionItem.qtype == 'ML' ||
                        questionItem.qtype == 'GC' ||
                        questionItem.qtype == 'SC'
                      ) {
                        answerText = '';
                      }
                      if (selectedOption.isOther) {
                        isOther = selectedOption.isOther;
                        if (questionItem.otherAnswer != null) {
                          answerText = questionItem.otherAnswer;
                        } else {
                          answerText = '';
                        }
                      } else {
                        isOther = false;
                      }
                      if (
                        (questionItem.qtype == 'C' ||
                          questionItem.qtype == 'ML') &&
                        questionItem.isValid &&
                        questionItem.ansConstraint != null
                      ) {
                        this.participationResponseData.ResponseCommanData.isConstraintAlert = true;
                      }
                      this.participationResponseData.ResponseDatas.push({
                        page_no: page_no,
                        AnswerID: answerID,
                        AnswerText: answerText,
                        QuestionID: questionID,
                        IsOther: isOther,
                        Qno: Qno,
                        QType: questionType,
                        BranchQID: BranchQID,
                      });
                    }
                  } else {
                    this.participationResponseData.ResponseDatas.push({
                      page_no: page_no,
                      AnswerID: answerID,
                      AnswerText: answerText,
                      QuestionID: questionID,
                      IsOther: isOther,
                      Qno: Qno,
                      QType: questionType,
                      BranchQID: BranchQID,
                    });
                  }
                } else {
                  let answerID, answerText;
                  if (
                    questionItem.population_type == 2 &&
                    questionItem.qtype == 'T' &&
                    (questionItem.qsubtype == 1 ||
                      questionItem.qsubtype == 2 ||
                      questionItem.qsubtype == 3 ||
                      questionItem.qsubtype == 4) &&
                    questionItem.AnswerText == null &&
                    questionItem.date_default != null
                  ) {
                    let currentDate;
                    if (
                      questionItem.qsubtype == 2 ||
                      questionItem.qsubtype == 4
                    ) {
                      currentDate = formatDate(new Date(), 'dd/M/yyyy', 'en');
                    } else {
                      currentDate = formatDate(new Date(), 'M/dd/yyyy', 'en');
                    }
                    answerID = questionItem.selectAnsValue;
                    if (questionItem.date_default == 'current') {
                      answerText = currentDate;
                    } else {
                      answerText = questionItem.date_default;
                    }
                  } else {
                    answerID = questionItem.selectAnsValue;
                    answerText = questionItem.AnswerText;
                  }
                  if (questionItem.isOtherAnswer) {
                    if (questionItem.otherAnswer != null) {
                      answerText = questionItem.otherAnswer;
                    } else {
                      answerText = '';
                    }
                  }
                  if (questionItem.qtype == 'RS') {
                    answerText = null;
                  }
                  if (questionItem.qtype == 'T') {
                    answerID = 0;
                  }
                  let questionID = questionItem.UniqueNumber;
                  let questionType = questionItem.qtype;
                  let isOther = questionItem.isOtherAnswer;
                  let Qno = questionItem.qno;
                  let page_no = questionItem.page_no;
                  let BranchQID;
                  this.participationResponseData.ResponseDatas.push({
                    page_no: page_no,
                    AnswerID: answerID,
                    AnswerText: answerText,
                    QuestionID: questionID,
                    IsOther: isOther,
                    Qno: Qno,
                    QType: questionType,
                    BranchQID: BranchQID,
                  });
                }
              }
            this.participationResponseData.ResponseCommanData.SurveyID =
              this.editResponseData.SurveySettings.zarca_id;
            this.participationResponseData.ResponseCommanData.ResponseUID =
              this.editResponseData.ResponseInfo.ResponseUID;
 
            this.participationResponseData.ResponseCommanData.isReopenSurvey =
              this.editResponseData.SurveyDetails.isSurveyReopened;
            this.participationResponseData.ResponseCommanData.isEmbedMobile =
              this.editResponseData.SurveyDetails.isEmbedMobile;
            this.participationResponseData.ResponseCommanData.Screen_Resolution =
              this.commonLogic.getResolution();
            this.participationResponseData.ResponseCommanData.dtResponseStartDate =
              this.editResponseData.SurveyDetails.dtResponseStartDate;
            this.participationResponseData.directoryLinkedQuestionDetails =
              this.editResponseData.directoryLinkedQuestionDetails;

            this.editResponseSearchModel.distributionID =parseInt(this.editResponseData.SurveyDetails.strFrom ?? "0")
            this.editResponseSearchModel.lang = this.editResponseData.SurveyDetails.selectedLangId;
            this.editResponseSearchModel.editResponseData = this.editResponseData;
            this.editResponseSearchModel.editResponseData.participationResponseData = this.participationResponseData;
            this.editResponseSearchModel.subMode = type;            

            // Check for textbox validation errors (range validation, etc.)
            const textboxValidationErrors = this.editResponseData.Questions.filter(
              question => (question.qtype === 'T' || question.qtype === 'C' || question.qtype === 'ML' || question.qtype === 'CS') && 
                          question.isValid && question.group_no == 0
            );

            // Check for ranking validation errors
            const rankingValidationErrors = this.editResponseData.Questions.filter(
              question => question.qtype === 'RK' && question.isValid && question.isAlertDanger
            );

              if (textboxValidationErrors.length > 0 || rankingValidationErrors.length > 0) {
              this.showLoader = false;
              this.changeDetect.detectChanges();
              return; 
            }

            let url = 'PostEdit';
              let ng5 = '50';
              this.service
                .EditResp(
                  url,
                  JSON.stringify(
                    EncryptionAndDecryption.EncryptionData(
                      '123456$#@$^@1ERF',
                      JSON.stringify(this.editResponseSearchModel),
                    ),
                  ),
                )
                .subscribe({
                  next: async (data) => {
                      this.showLoader = false;
                      this.changeDetect.detectChanges();
                     if (window.opener && typeof window.opener.goToRec1 === 'function') {
                      window.opener.goToRec1(this.responseSrNo);
                      }  

                      setTimeout(() => {
                        window.close();                        
                      }, 100);
                  },
                  error: (error) => {
                    this.errorsHandlerService.handleError(error);
                    if (error.name == 'HttpErrorResponse') {
                      window.location.replace('../survey/sd?err=1&ng=' + ng5 + '&cn=' + this.editResponseData.CorpSettings.corporate_no);
                    }
                  }
                });
          }

          closeModel(){
            window.close();
          }
}
